module.exports = __webpack_public_path__ + "static/media/logo.1d39d392.png";